import { Inject, Injectable } from "@angular/core";

import { INFRA_SETTINGS } from "@hermes/app-core";
import { InfraSettings } from "@hermes/env-infra";
import { HeadService } from "@hermes/utils-generic/services/head";

import {
    BreadcrumbSection,
    ListElement,
    StucturedDataBreadcrumb,
} from "../models/breadcrumb.model";
@Injectable({ providedIn: "root" })
export class BreadcrumbHeadService {
    constructor(
        private headService: HeadService,
        @Inject(INFRA_SETTINGS) private infraSettings: InfraSettings,
    ) {}

    public addBreadcrumbStructuredData(
        breadcrumbSections: BreadcrumbSection[],
    ): void {
        this.headService.addScript(
            JSON.stringify(
                this.getStructuredDataForBreadcrumb(breadcrumbSections),
            ),
            "application/ld+json",
            "BreadcrumbList",
        );
    }

    private getStructuredDataForBreadcrumb(
        data: BreadcrumbSection[],
    ): StucturedDataBreadcrumb {
        return {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: this.getListElement(data),
        };
    }

    private getListElement(
        breadcrumbSections: BreadcrumbSection[],
    ): ListElement[] {
        return breadcrumbSections.map((breadcrumbSection, index) =>
            this.getElement(breadcrumbSection, index),
        );
    }

    private getElement(
        breadcrumbSection: BreadcrumbSection,
        index: number,
    ): ListElement {
        return {
            "@type": "ListItem",
            position: index + 1,
            name: breadcrumbSection.value || "",
            item:
                `${this.infraSettings.frontend}${breadcrumbSection.url}` || "",
        };
    }
}
